import Image from 'next/image'
import styled from 'styled-components'

export const InteractiveContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .image-button {
    border: none;
    cursor: pointer;
    appearance: none;
    background-color: inherit;
  }

  .page-turner {
    min-width: 30%;
    display: flex;
    flex-direction: row;
    gap: 24px;
  }

  .info-button {
    align-self: flex-end;
    button {
      font-size: 24px;
    }
    @media (max-width: 791px) {
      button {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 500px) {
    .page-turner {
      gap: 8px;
    }
  }
`

export const ArrowImage = styled(Image)`
  width: 26.67px;
  min-width: 13px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.3);
  }
`
